<!-- Volume & Pipeline / Risk & Prediction Tabs Section -->

    <!-- Tabs Header -->
    <div class="analytics-tabs-header">
        <button class="analytics-tab-button" [ngClass]="{'active': activeAnalyticsTab === 'volume'}" (click)="selectAnalyticsTab('volume')">
            <span class="material-icons">trending_up</span>
            Volume & Pipeline
        </button>
        <button class="analytics-tab-button" [ngClass]="{'active': activeAnalyticsTab === 'risk'}" (click)="selectAnalyticsTab('risk')">
            <span class="material-icons">warning</span>
            Risk & Prediction
        </button>
    </div>

    <!-- Volume & Pipeline Tab Content -->
    <div class="analytics-tab-content" *ngIf="activeAnalyticsTab === 'volume'">
        <div class="analytics-cards-container">
            <!-- Email Volume Trend Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Email Volume Trend</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #emailVolumeTrendChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Classification Split Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Classification Split</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #classificationSplitChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- NDA Template Distribution Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">NDA Template Distribution (LT vs X)</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #ndaTemplateChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- NDA Negotiations by Counterparty Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">NDA Negotiations by Counterparty (Top 5)</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #ndaNegotiationsChart class="analytics-chart"></svg>
                </div>
            </div>
        </div>
    </div>

    <!-- Risk & Prediction Tab Content -->
    <div class="analytics-tab-content" *ngIf="activeAnalyticsTab === 'risk'">
        <div class="analytics-cards-container">
            <!-- Escalation Distribution Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Escalation Distribution</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #escalationDistributionChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Case Aging Queue Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Case Aging Queue</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #caseAgingQueueChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Escalation by Counterparty Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Escalation by Counterparty (Top 12)</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #escalationCounterpartyChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Top Friction Clauses Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Top Friction Clauses (Reject + Negotiate)</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #topFrictionClausesChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Escalation Trend Over Time Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Escalation Trend Over Time</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #escalationTrendChart class="analytics-chart"></svg>
                </div>
            </div>

            <!-- Review NDA - Escalation Reasons Card -->
            <div class="analytics-card">
                <div class="analytics-card-header">
                    <h4 class="analytics-card-title">Review NDA - Escalation Reasons (Hard & Soft)</h4>
                </div>
                <div class="analytics-card-body">
                    <svg #escalationReasonsChart class="analytics-chart"></svg>
                </div>
            </div>
        </div>
    </div>
